/* eslint-disable react/style-prop-object */
import React, { useContext, useState } from "react";
import Searchbar from "../../Helpers/Searchbar/Searchbar";
import { filtrationcontext } from "../../../context/Filtercontext";
import trans from "../../../utils";

export default function UsersHead({ extra }) {
	//const [activeItem, setActiveItem] = useState("All vehicles");
	const { setSearchQuery } = useContext(filtrationcontext);
	const [query, setQuery] = useState("");
	const handleSearch = (e) => {
		setQuery(e.target.value);
		setSearchQuery(e.target.value);
	};

	return (
		<>
			<div className="bg-white p-16">
				<div className="flex-between">
					<Searchbar
						style="search search-dark input-group"
						path={`${process.env.PUBLIC_URL}/assets/Search.svg`}
						placeholder={trans("Search")}
						value={query}
						onChange={handleSearch}
					/>
					{extra}
				</div>
			</div>
		</>
	);
}
